import { render, staticRenderFns } from "./Yushou.vue?vue&type=template&id=9fb4bbba&scoped=true&"
import script from "./Yushou.vue?vue&type=script&lang=js&"
export * from "./Yushou.vue?vue&type=script&lang=js&"
import style0 from "./Yushou.vue?vue&type=style&index=0&id=9fb4bbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb4bbba",
  null
  
)

export default component.exports